module.exports = __webpack_public_path__ + "static/media/satellite-road-labels.1ab4d69d.svg";